var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userleft"},[_c('ul',_vm._l((_vm.usernav),function(item,i){return _c('li',{key:i},[_c('router-link',{attrs:{"to":item.to}},[_c('strong',[_vm._v(_vm._s(item.name))])])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }